<template>
  <i class="material-icons customer-device-icon" :title="title">{{ iconName }}</i>
</template>

<script>
export default {
  props: {
    orderSource: { type: String, default: null }
  },
  computed: {
    iconName() {
      switch (this.orderSource) {
        case 'mobile': return 'smartphone'
        case 'web': return 'language'
        case 'admin': return 'verified_user'
        default: return 'help_outline'
      }
    },
    title() {
      switch (this.orderSource) {
        case 'mobile': return this.$t('customerDeviceIcon.orderedViaMobileApp')
        case 'web': return this.$t('customerDeviceIcon.orderedViaWeb')
        case 'admin': return this.$t('customerDeviceIcon.addedByAdminStaff')
        default: return this.$t('customerDeviceIcon.unknownSourceLegacyOrder')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/customerDeviceIcon.vue